import { createSlice } from "@reduxjs/toolkit";
import {
  getJobs,
  getJobById,
  createJob,
  updateJob,
  jobAction,
  deleteJob,
  completeJob,
  actionUploadedWork,
  createTicket,
} from "./jobService";

// Initial state
const initialState = {
  jobs: [],
  currentJob: null,
  tickets: [],
  loading: false,
  error: null,
};

// Job slice
const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    clearJobErrors: (state) => {
      state.error = null;
    },
    clearJobData: (state) => {
      state.jobs = [];
      state.currentJob = null;
      state.tickets = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Jobs
    builder
      .addCase(getJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = action.payload.data;
      })
      .addCase(getJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Job by ID
      .addCase(getJobById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentJob = action.payload.data;
      })
      .addCase(getJobById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create Job
      .addCase(createJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = [...state.jobs, action.payload.data];
      })
      .addCase(createJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Job
      .addCase(updateJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJob.fulfilled, (state, action) => {
        state.loading = false;
        const updatedJobId = action.payload.id;

        state.jobs = state.jobs.map((job) =>
          job.id === updatedJobId ? { ...job, ...action.payload.data } : job
        );

        if (state.currentJob && state.currentJob.id === updatedJobId) {
          state.currentJob = { ...state.currentJob, ...action.payload.data };
        }
      })
      .addCase(updateJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Job Action (Accept/Reject)
      .addCase(jobAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(jobAction.fulfilled, (state, action) => {
        state.loading = false;

        // Update the job in the jobs array if it exists
        state.jobs = state.jobs.map((job) =>
          job.id === action.payload.aid
            ? {
                ...job,
              }
            : job
        );

        // Update the current job if it matches
        if (state.currentJob && state.currentJob.id === action.payload.aid) {
          state.currentJob = {
            ...state.currentJob,
          };
        }
      })
      .addCase(jobAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Action Uploaded Work
      .addCase(actionUploadedWork.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(actionUploadedWork.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(actionUploadedWork.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create Ticket
      .addCase(createTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTicket.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.data) {
          state.tickets = [...state.tickets, action.payload.data];
        }
      })
      .addCase(createTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Job
      .addCase(deleteJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJob.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = state.jobs.filter((job) => job.id !== action.meta.arg);
        if (state.currentJob && state.currentJob.id === action.meta.arg) {
          state.currentJob = null;
        }
      })
      .addCase(deleteJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Complete Job
      .addCase(completeJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(completeJob.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(completeJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearJobErrors, clearJobData } = jobSlice.actions;
export default jobSlice.reducer;
